$(function () {
	$('a[href*=\\#]:not([href=\\#])').click(function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
			if ($target.length) {
				if ($(this).parents('.menuBox').length) {
					setTimeout(function () {
						var targetOffset = $target.offset().top;
						$('html,body').animate({
							scrollTop: targetOffset
						}, 1000);
					}, 100);
				} else {
					var targetOffset = $target.offset().top;
					$('html,body').animate({
						scrollTop: targetOffset
					}, 1000);
				}
				return false;
			}
		}
	});
	$("#gHeader .hList > li:has(.naviBox)").hover(function () {
		$(this).children("a").addClass("on");
		$(this).children(".naviBox").show();
	}, function () {
		$(this).children("a").removeClass("on");
		$(this).children(".naviBox").hide();
	});
	
	$('#gHeader .menu').click(function(){
		$('.menuBox').slideToggle(300);
		return false;	
	});	
	$('.menuBox .close').click(function(){
		$('.menuBox').slideUp(300);
	});
	$('#gHeader .menu01').click(function(){
		$('.menuBox01').slideToggle(300);
		return false;	
	});	
	$('.menuBox01 .close').click(function(){
		$('.menuBox01').slideUp(300);
	});
	$('#main .sec04 .slideBox').slick({
		dots: false,
		infinite: true,
		arrows: true,
		autoplay: true,
		centerMode: false,
		variableWidth: true,
		centerPadding: '0',
		prevArrow: '#main .sec04 .arrow .prev',
	    nextArrow: '#main .sec04 .arrow .next',
	});
	$(".comSearchBox .topUl span").click(function(){
	    $(this).toggleClass("on");
	    $('.comSearchBox .bgBox').slideToggle(300);
	    return false;
	  });
	  $('.comSearchBox .bgBox .close').click(function () {
	    $('.comSearchBox .bgBox').stop().slideUp();
	    $('.comSearchBox .topUl span').removeClass('on');
	    state = false;
	  });
});

$(window).on('load', function () {
	var localLink = window.location + '';
	if (localLink.indexOf("#") != -1 && localLink.slice(-1) != '#') {
		localLink = localLink.slice(localLink.indexOf("#") + 1);
		$('html,body').animate({
			scrollTop: $('#' + localLink).offset().top
		}, 500);
	}
});
// Handle registration redirect
var $returnTo = $('<input type="hidden" name="return_to" value="/account/register#done"/>');
if ($('#g-recaptcha').length){ //if captcha form
   $returnTo.insertBefore($('.shopify-challenge__container input[type="submit"]'));
}
